import facebookPixel from './scripts'

const facebookPixelWrapper = (() => {
  const props = {
    actionsQueue: [],
    debug: false,
    initialized: false
  }

  const log = (...args) => {
    console.info(...['[react-facebook-pixel]'].concat(args))
  }

  const defaultOptions = {
    autoConfig: true,
    debug: false
  }

  const init = (pixelId, advancedMatching = {}, options = defaultOptions) => {
    facebookPixel()

    if (!pixelId) { console.log('Please insert pixel id for initializing') } else {
      const { fbq } = window

      if (options.autoConfig === false) { fbq('set', 'autoConfig', false, pixelId) }

      fbq('init', pixelId, advancedMatching)
      props.actionsQueue.forEach(action => fbq(...action))
      props.initialized = true
      props.debug = options.debug
    }
  }

  const track = (title, data) => {
    const { fbq } = window

    if (!props.initialized) {
      props.actionsQueue.push(['track', title, data])
      return
    }

    fbq('track', title, data)

    if (props.debug) {
      log(`called fbq('track', '${title}');`)

      if (data) { log('with data', data) }
    }
  }

  const trackCustom = (title, data) => {
    const { fbq } = window

    if (!props.initialized) {
      props.actionsQueue.push(['trackCustom', title, data])
      return
    }

    fbq('trackCustom', title, data)

    if (props.debug) {
      log(`called fbq('trackCustom', '${title}');`)

      if (data) { log('with data', data) }
    }
  }

  return {
    init,
    track,
    trackCustom
  }
})()

export default facebookPixelWrapper
